import { Stack, Text } from "@chakra-ui/react";
import PatientDocumentPOCItem from "../../PatientDocumentPOCItem/PatientDocumentPOCItem";
import { EditorShell } from "./EditorShell";
import { isAnswerChanged, useEditorDraft } from "./editorValues";
import { readPocAnswer } from "./pocValue";
import type { QuestionEditorProps } from "./types";

// Editor of POC: the existing PatientDocumentPOCItem (the classic modal's POC component) in edit
// mode. Its `onChangeAnswer` gives the whole `POCItemsDocumentAnswer[]`, kept as the draft; Save
// writes it at the question's chart row (-1 outside a chart, as the classic modal and mobile do).

export function PocQuestionEditor(props: QuestionEditorProps) {
  const stored = readPocAnswer(props.value);
  const { draft, isTouched, updateDraft } = useEditorDraft(() => stored.items);

  return (
    <EditorShell
      canSave={isTouched && isAnswerChanged(props.value, draft)}
      error={props.error}
      isSaving={props.isSaving}
      label={props.question.label || "Plan of Care"}
      onCancel={props.onCancel}
      onSave={() => props.onSave(draft ?? [])}
    >
      <Stack spacing={2}>
        {!stored.isReadable && !isTouched && (
          <Text color="orange.600" fontSize="xs">
            The stored answer could not be read as plan-of-care items. It is kept unless you pick
            items.
          </Text>
        )}
        <PatientDocumentPOCItem
          currentAnswer={{
            answer: stored.items,
            answeredAt: null,
            chartRow: props.chartRow,
            questionId: props.question.id,
          }}
          item={props.question}
          readonly={props.isSaving}
          onChangeAnswer={(_questionId, _chartRow, answer) => updateDraft(answer)}
        />
      </Stack>
    </EditorShell>
  );
}
